import { gql } from '@apollo/client';

import { fragments as mediaFragments } from '../Media';
import { stickerFragment } from '../Sticker';

export const fragments = {
  all: gql`
    fragment ImageAll on Image {
      sys {
        id
      }
      media {
        ...AssetAll
      }
      mobileMedia {
        ...AssetAll
      }
      wrap
      enableHighDpi
      quality
      stickersCollection {
        items {
          ...StickerAll
        }
      }
    }
    ${mediaFragments.all}
    ${stickerFragment}
  `,
};

export const query = gql`
  query ImageQuery($preview: Boolean!, $locale: String!, $id: String!) {
    image(preview: $preview, locale: $locale, id: $id) {
      ...ImageAll
    }
  }
  ${fragments.all}
`;
